import { getSpotlights } from '@/common/integrations/menhir/employee/spotlights/spotlights.service';
import { TSpotlights } from '@/common/integrations/menhir/employee/spotlights/spotlights.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

export function useGetSpotlights(config?: UseQueryOptions<TSpotlights>) {
  const { data: spotlights, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.SPOTLIGHTS],
    queryFn: getSpotlights,
    ...config,
  });
  return { spotlights, ...rest };
}

export const useIsUpgradePeriodActive = () => {
  const { spotlights } = useGetSpotlights();

  return Boolean(spotlights?.insurance?.upgradePeriod?.active);
};
